import styled, { css } from 'styled-components';
import { Cell } from 'griding';
import { Link } from 'gatsby';

export const Footer = styled.footer`
  background: #36e8ba4f;
`;

export const FooterContent = styled.div`
  color: #000000a6;
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
  padding: 1em 1em;
  padding-top: 2em;
  padding-bottom: 2em;

  h1 {
    font-size: 24px;
  }

  a {
    text-decoration: underline;
    color: inherit;
  }

  p + p {
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
  }
`;

export const ArticleWrapper = styled.div`
  margin-bottom: 20px;
  margin-top: 10px;

  @media (min-width: 480px) {
    flex-grow: 1;
  }
`;

export const Article = styled.article`
  border-bottom: 1px solid #eee;
  margin-bottom: 24px;

  @media (min-width: 480px) {
    display: flex;
  }
`;

export const Title = styled.h1`
  margin-top: 0.3em;
  margin-bottom: 0.2em;
`;

const infoStyles = css`
  color: #999;
  font-weight: bold;
  margin-bottom: 0;
  font-size: 0.8rem;
  display: inline-block;
  margin-right: 2em;
  font-family: Montserrat, sans-serif;

  a {
    color: inherit;
  }
`;

export const Author = styled.p`
  ${infoStyles}
  line-height: 1;
  margin-top: 7px;

  a {
    text-decoration: none;
    border-bottom: 1px solid #ccc;
    line-height: 14px;
    display: inline-block;
  }
`;

export const DateText = styled.p`
  ${infoStyles}
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 0.6em;

  &:after {
    content: '';
    width: 1em;
    display: inline-block;
    border-top: 1px solid #ddd;
    margin-left: 2em;
    position: relative;
    top: -2px;
  }
`;

export const Category = styled.p`
  ${infoStyles}
  text-align: right;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 0.6em;

  a {
    text-decoration: none;
    border-bottom: 1px solid #ccc;
    line-height: 14px;
    display: inline-block;
  }
`;

export const Description = styled.p`
  margin-top: 0.2em;
`;

export const ReadMore = styled.p`
  margin-top: 1em;
  a {
    color: #cdba2d;
  }
`;

export const ImageWrapper = styled.div`
  @media (min-width: 480px) {
    width: 150px;
    flex-grow: 1;
    margin-right: 50px;
    margin-top: 45px;
  }
`;

export const AuthorName = styled.h5``;

export const AuthorImage = styled.div`
  padding-left: 20px;
  float: right;
  width: 100px;
  text-align: center;

  span {
    display: inline-block;
    margin-top: 5px;
  }
`;

export const Image = styled.div`
  border-radius: 2px;

  picture {
    display: block;
    margin-bottom: 0;
    max-width: 100%;
    width: 100px;
    @media (min-width: 480px) {
      max-width: 150px;
    }
  }
`;

export const FeaturedImage = styled.div`
  margin-left: -1em;
`;

export const FeaturedInfos = styled(Cell)`
  margin-top: 25%;
  margin-left: 20%;
  padding-bottom: 25%;
  width: 80%;
  border-bottom: 1px solid #eee;
`;

export const PaginationWrapper = styled.div`
  text-align: center;
  margin-bottom: 2em;
`;

export const PaginationLabel = styled.span`
  margin-right: 5px;
`;

export const Pagination = styled.ul`
  list-style: none;
  display: inline;
`;

export const PaginationItem = styled.li`
  display: inline-block;
  text-align: center;

  a,
  span {
    display: inline-block;
    padding: 10px 10px;
  }

  ${({ current }) =>
    current &&
    css`
      font-weight: bold;
    `}
`;

export const HeaderSectionTitle = styled.h1`
  margin-top: 1em;
`;

export const HeaderSectionLink = styled(Link)`
  margin-right: 1em;
`;

export const HeaderSectionList = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const PostImage = styled.div`
  margin-bottom: 20px;

  img {
    width: 100%;
    max-width: 100%;
  }
`;

export const BlogContent = styled.div`
  margin: 0.2rem 0;
`;

export const OtherContent = styled.div`
  padding-bottom: 2rem;
`;

const navigationPostStyles = css`
  margin-bottom: 1rem;
  font-size: 1.1rem;
  display: block;
  padding-top: 1rem;
  line-height: 120%;
  font-family: Montserrat, sans-serif;
  border-top: 1px solid #eaeaea;

  a {
    color: inherit;
  }
`;

export const NextNavigationPost = styled.div`
  ${navigationPostStyles}
  text-align: right;
`;

export const PrevNavigationPost = styled.div`
  ${navigationPostStyles}
`;
